import { Helmet } from "react-helmet-async";

const SITE_URL = "https://realixdata.com";
const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop&q=80";

export default function SEOHead({
  title,
  description,
  canonical,
  type = "website",
  image,
  jsonLd,
  noindex = false,
}) {
  const fullCanonical = canonical
    ? (canonical.startsWith("http") ? canonical : `${SITE_URL}${canonical}`)
    : `${SITE_URL}${typeof window !== 'undefined' ? window.location.pathname : '/'}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      <link rel="canonical" href={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@RealixData" />
      {jsonLd && (
        Array.isArray(jsonLd)
          ? jsonLd.map((ld, i) => <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>)
          : <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
